import consoleFourTrackers from './includes/console-four-trackers.js';
import fightcampQuickWraps from './includes/fightcamp-quick-wraps.js';
import fightcampAnkleWraps from './includes/fightcamp-ankle-wraps.js';
import fightcampBoxingBag from './includes/fightcamp-boxing-bag.js';
import fightcampBagRing from './includes/fightcamp-bag-ring.js';
import fightcampGloves from './includes/fightcamp-gloves.js';
import fightcampHeartRateMonitor from './includes/fightcamp-heart-rate-monitor.js';

export default [
  {
    testShopifyId: 'gid://shopify/Product/7977363996761',
    prodShopifyId: 'gid://shopify/Product/8945312432364',
    pathId: 'shop/products/fightcamp-connect',
    title: 'Connect',
    price: '$299',
    description: 'Elevate your boxing setup with FightCamp’s core technology. Ideal for those with a bag and gloves who only need the essentials.',
    includes: [
      consoleFourTrackers,
      fightcampQuickWraps,
      fightcampAnkleWraps,
    ],
    includesBag: false,
    assets: [
      {
        src: 'https://a.storyblok.com/f/152150/1200x960/1dc2de93c3/packages_connect_above.jpg',
        alt: 'FightCamp Package',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1001x1000/2085a1b94c/fc-product-carousel-4.jpg',
        alt: 'FightCamp quick wraps with trackers',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1200x1200/050aaf5975/a15a9127.jpg',
        alt: 'FightCamp console mounted on wall, person is lifting tracker from it.',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1200x825/0b0017640d/gen2_finals-20.jpg',
        alt: 'Man punching a bag with fightcamp console in the background, a workout playing on tv.',
      },
    ],
  },
  {
    testShopifyId: 'gid://shopify/Product/7977374154841',
    prodShopifyId: 'gid://shopify/Product/8945313054956',
    pathId: 'shop/products/fightcamp-complete',
    title: 'Complete',
    price: '$699',
    description: 'The ideal starter kit. Includes everything you need to transform any room into your personal boxing gym with our premium gear and tech.',
    includes: [
      consoleFourTrackers,
      fightcampQuickWraps,
      fightcampAnkleWraps,
      fightcampBoxingBag,
    ],
    includesBag: true,
    assets: [
      {
        src: 'https://a.storyblok.com/f/152150/1200x1120/2654bcb4bc/fcpackage_good.jpg',
        alt: 'FightCamp Package',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1001x1000/a5b659c1ff/fc-product-carousel-5.jpg',
        alt: 'Person working out with FightCamp',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1200x825/bbc82c8f34/qi6h1257.jpg',
        alt: 'Man sitting on floor punching bag while doing FightCamp workout',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1200x825/7aaff30fe2/fightcamp-la-marketing-content-photos-22909.jpg',
        alt: 'FightCamp user punching free standing bag',
      },
    ],
  },
  {
    testShopifyId: 'gid://shopify/Product/7977374220377',
    prodShopifyId: 'gid://shopify/Product/8945313317100',
    pathId: 'shop/products/fightcamp-elite',
    title: 'Elite',
    price: '$899',
    description: 'The full FightCamp package. Premium gear, tech, and everything you\'ll need for the most immersive at home training.',
    includes: [
      consoleFourTrackers,
      fightcampQuickWraps,
      fightcampAnkleWraps,
      fightcampBoxingBag,
      fightcampBagRing,
      fightcampGloves,
      fightcampHeartRateMonitor,
    ],
    includesBag: true,
    assets: [
      {
        src: 'https://a.storyblok.com/f/152150/1200x1120/e0bf6133e0/fcpackage_best.jpg',
        alt: 'FightCamp Package',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1200x825/3506489a12/2021-12-08-_-fc-new-years-224-copy_1.jpg',
        alt: 'FightCamp user taking kickboxing class',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1200x825/27ef6bf51c/a15a7997-edit-copy_1.jpg',
        alt: 'FightCamp user taking boxing class in garage, FightCamp workout playing on tv',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1001x1000/2085a1b94c/fc-product-carousel-4.jpg',
        alt: 'FightCamp quick wraps with trackers',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1001x1000/a5b659c1ff/fc-product-carousel-5.jpg',
        alt: 'Person working out with FightCamp',
      },
    ],
  },
];
